import { Candidate } from 'types/candidates/types';

type ClaimableCandidate = Pick<
  Candidate,
  'id' | 'procedureId' | 'vacancyId' | 'customerId'
>;

/**
 * What identifies "the candidate this page already claimed a campaign for".
 */
export const campaignClaimKey = (candidate: ClaimableCandidate) =>
  candidate.procedureId ?? candidate.id;

/**
 * Whether the candidate page should make the candidate's campaign the selected
 * one. Once per loaded candidate, never again for the same one: re-claiming on
 * every change of the selected campaign made tabs on different campaigns
 * overrule each other without end (SYM-6385).
 */
export const shouldClaimCampaign = (
  candidate: ClaimableCandidate,
  claimedFor: number | undefined
) =>
  !!candidate.customerId &&
  !!candidate.vacancyId &&
  campaignClaimKey(candidate) !== claimedFor;
